import { render, staticRenderFns } from "./Amazonsearch.vue?vue&type=template&id=4bf45b78"
import script from "./Amazonsearch.vue?vue&type=script&lang=js"
export * from "./Amazonsearch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports